var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditDomicile.jinja');
require('./MemberProfileEditDomicile.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditDomicile-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditDomicile-buttons-button--save': 'saveEdit',
        'change select[name="domicile_country"]': 'updateDomicileStateVisibility',
        'focus select': 'resetStateError',
    },

    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'saveApi');

        this.updateDomicileStateVisibility();

        Base.prototype.initialize.call(this, options);
    },

    updateDomicileStateVisibility: function () {
        var $form = this.$('.MemberProfileEditDomicile-body-form');
        var country = $('select[name="domicile_country"]', $form).val();
        var $state = $('select[name="domicile_state"]', $form);
        var $stateBlock = $('.MemberProfileEditDomicile-body-inputsBlockState', $form);
        var isUSA = country == 470; // TODO

        $stateBlock.toggleClass('MemberProfileEditDomicile-body-inputsBlock--hidden', !isUSA);

        this.resetStateError();

        if (!isUSA) {
            $state.val(0);
        }
    },

    setStateError: function () {
        var $form = this.$('.MemberProfileEditDomicile-body-form');
        var $stateBlock = $('.MemberProfileEditDomicile-body-inputsBlockState', $form);
        $stateBlock.addClass('MemberProfileEditDomicile-body-inputsBlock--error');
    },

    resetStateError: function () {
        var $form = this.$('.MemberProfileEditDomicile-body-form');
        var $stateBlock = $('.MemberProfileEditDomicile-body-inputsBlockState', $form);
        $stateBlock.removeClass('MemberProfileEditDomicile-body-inputsBlock--error');
    },

    saveEdit: function () {
        var $form = this.$('.MemberProfileEditDomicile-body-form');
        var domicile = {
            'country': $('select[name="domicile_country"]', $form).val(),
            'state': $('select[name="domicile_state"]', $form).val(),
        }

        var isUSA = domicile.country == 470; // TODO
        if (isUSA && domicile.state == 0) {
            this.setStateError();
            return
        }

        var $button = this.$('.MemberProfileEditDomicile-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                domicile: domicile
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateDomicile', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t update domicile!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'domicile');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditDomicile.js
// module id = 211
// module chunks = 0